import Vue from 'vue';
import config from '../../config/index';

export default {
  // 获取机构下拉列表
  getOrgList() {
    return Vue.axios.get(`${config.base_url}/roses-platform/sysOrg/list`);
  },
  // 获取设备大类下拉列表
  getDeviceCategoryList() {
    return Vue.axios.get(`${config.base_url}/roses-platform/deviceCategory/list`);
  },
  // 获取设备小类下拉列表 
  getDeviceTypeList(params) {
    return Vue.axios.get(`${config.base_url}/roses-platform/deviceType/list?categoryId=${params}`);
  },
  // 获取设备列表
  getEquipmentList(params) {
    return Vue.axios.get(`${config.base_url}/roses-platform/device/page`, { params });
  },
  // 获取唯一标书 
  getSystemUniqueNo(params) {
    return Vue.axios.get(`${config.base_url}/roses-platform/sysOrg/getSystemUniqueNo?orgId=${params}`);
  },
  // 新增设备
  postNewDevice(params) {
    return Vue.axios.post(`${config.base_url}/roses-platform/device/add`, params);
  },
  // 编辑设备
  postEditDevice(params) {
    return Vue.axios.post(`${config.base_url}/roses-platform/device/edit`, params);
  },
  //删除设备
  delDevice(params) {
    return Vue.axios.post(`${config.base_url}/roses-platform/device/delete`, params);
  },
  // 编辑时获取设备详情
  getDeviceDetail(params) {
    return Vue.axios.get(`${config.base_url}/roses-platform/device/detail?id=${params}`);
  },
  // 查询类型列表
  getDeviceTypePage(params) {
    return Vue.axios.get(`${config.base_url}/roses-platform/deviceType/page`, { params });
  },
  // 新增设备类型
  postNewType(params) {
    return Vue.axios.post(`${config.base_url}/roses-platform/deviceType/add`, params);
  },
  // 编辑设备类型
  postEditType(params) {
    return Vue.axios.post(`${config.base_url}/roses-platform/deviceType/edit`, params);
  },
  // 获取授权机构列表
  getOrgListTable(params) {
    return Vue.axios.get(`${config.base_url}/roses-platform/sysOrg/deviceList`, { params });
  },
  // 获取授权的机构下拉列表
  getGrantedOrgList(params) {
    return Vue.axios.get(`${config.base_url}/roses-platform/sysOrg/grantedOrgInfo?orgId=${params}`);
  },
  // 查询授权给机构的设备详情 
  getGrantedDeviceDetail(params) {
    return Vue.axios.get(`${config.base_url}/roses-platform/device/grantedDeviceInfo`, { params });
  },
  // 获取设备树 /roses-platform/device/grantTree
  getGrantTree(params) {
    return Vue.axios.get(`${config.base_url}/roses-platform/device/grantTree?orgId=${params}`);
  },
  // 确认授权 
  postDeviceGranted(params) {
    return Vue.axios.post(`${config.base_url}/roses-platform/device/grant`, params);
  },
  // 取消授权 
  postCancelGranted(params) {
    return Vue.axios.post(`${config.base_url}/roses-platform/device/cancelGrant`, params);
  }
};
